<div class="check-in-container container mt-4">

    <!-- DATOS DE LA RESERVA -->
    <div class="space-y-4">

        <div class="check-in-section">
            <div class="mb-4">
                <h3 class="section-title">Datos de la Reserva</h3>
                <div class="reservation-header">
                    <div class="row">
                        <div class="col-2">
                            <strong>Fecha de Reserva</strong><br>
                            <span>{{ reservationData?.createdDate | date }}</span>
                        </div>
                        <div class="col-2">
                            <strong>Check-in</strong><br>
                            <span>{{ reservationData?.checkInDate | date }}</span>
                        </div>
                        <div class="col-2">
                            <strong>Check-out</strong><br>
                            <span>{{ reservationData?.checkOutDate | date }}</span>
                        </div>
                        <div class="col-2">
                            <strong>Huéspedes</strong><br>
                            <span>{{ reservationData?.guestCount }}</span>
                        </div>
                        <div class="col-2">
                            <strong>Monto total</strong><br>
                            <span>{{ '$' + reservationData?.totalPrice }}</span>
                        </div>
                    </div>
                    <div class="mt-4">
                        <strong>Observaciones generales</strong>
                        <p>{{reservationData?.observations}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <form [formGroup]="guestsForm">
        <mat-accordion>
            <div *ngFor="let detail of reservationData?.reservationDetails" class="check-in-section">
                <div class="room-title">
                    <h3><b>Habitación {{ detail.room.name }}</b></h3>
                    <button mat-mini-fab type="button" class="float-right custom-fab-blue-circle"
                        aria-label="Agregar huésped" title="Agregar huésped" [disabled]="!canAddGuest(detail.id)"
                        (click)="addGuestForRoom(detail.id)">
                        <mat-icon>person_add</mat-icon>
                    </button>
                </div>

                <div cdkDropList [cdkDropListData]="getGuestsForRoom(detail.id)"
                    [cdkDropListConnectedTo]="connectedDropListIds" [id]="'room-' + detail.id"
                    (cdkDropListDropped)="onGuestDropped($event, detail.id)" class="dropzone">
                    <ng-container *ngIf="getGuestsForRoom(detail.id).length; else emptyPlaceholder">
                        <div *ngFor="let guest of getGuestsForRoom(detail.id); let j = index" cdkDrag
                            [cdkDragData]="guest" class="mb-2">
                            <div [formGroup]="guest">
                                <mat-expansion-panel>
                                    <mat-expansion-panel-header>
                                        <mat-panel-title>
                                            <span class="ml-3">
                                                {{guest.get('firstName') && guest.get('firstName')?.value != '' ?
                                                guest.get('firstName')?.value + ' ' +
                                                guest.get('lastName')?.value :
                                                'Nuevo huésped'}}
                                            </span>
                                            <b class="ml-2">
                                                {{guest.get('isBookingPerson')?.value ? 'RESPONSABLE' : ''}}
                                            </b>
                                        </mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <div class="row">
                                        <div class="col-md-6">

                                            <mat-form-field appearance="outline" class="w-100">
                                                <mat-label>Tipo de documento</mat-label>
                                                <mat-select formControlName="documentType" tabindex="1">
                                                    <mat-option [value]="">Seleccione...</mat-option>
                                                    <mat-option *ngFor="let type of documentTypes" [value]="type.value">
                                                        {{ type.label }}
                                                    </mat-option>
                                                </mat-select>
                                            </mat-form-field>

                                            <mat-form-field appearance="outline" class="w-100">
                                                <mat-label>Nombre</mat-label>
                                                <input matInput formControlName="firstName" tabindex="3" />
                                            </mat-form-field>

                                            <mat-form-field appearance="outline" class="w-100">
                                                <mat-label>Código de área</mat-label>
                                                <input matInput formControlName="areaCode" tabindex="5"
                                                    placeholder="Sin 0 - ej: +54388" />
                                            </mat-form-field>

                                            <mat-form-field appearance="outline" class="w-100">
                                                <mat-label>Email</mat-label>
                                                <input matInput formControlName="email" type="email" tabindex="7"
                                                    placeholder="ej: email@email.com" />
                                            </mat-form-field>

                                            <mat-form-field appearance="outline" class="w-100">
                                                <mat-label>País de origen</mat-label>
                                                <mat-select formControlName="countryOfOrigin" tabindex="9">
                                                    <mat-option>
                                                        <ngx-mat-select-search [formControl]="countryFilterCtrl"
                                                            placeholderLabel="Buscar país..."></ngx-mat-select-search>
                                                    </mat-option>
                                                    <mat-option>Seleccione...</mat-option>
                                                    <mat-option *ngFor="let country of filteredCountries"
                                                        [value]="country.name">
                                                        {{ country.name }}
                                                    </mat-option>
                                                </mat-select>
                                            </mat-form-field>

                                            <mat-form-field appearance="outline" class="w-100">
                                                <mat-label>Nacionalidad</mat-label>
                                                <input matInput formControlName="nationality" tabindex="11" />
                                            </mat-form-field>

                                            <mat-form-field appearance="outline" class="w-100">
                                                <mat-label>Marca vehículo</mat-label>
                                                <input matInput formControlName="vehicleMakeModel" tabindex="13" />
                                            </mat-form-field>
                                        </div>

                                        <div class="col-md-6">

                                            <mat-form-field appearance="outline" class="w-100">
                                                <mat-label>Número de documento</mat-label>
                                                <input matInput formControlName="documentNumber"
                                                    (keydown.enter)="tryAutoFillGuest(guest)"
                                                    (blur)="tryAutoFillGuest(guest)" tabindex="2" />
                                            </mat-form-field>

                                            <mat-form-field appearance="outline" class="w-100">
                                                <mat-label>Apellido</mat-label>
                                                <input matInput formControlName="lastName" tabindex="4" />
                                            </mat-form-field>

                                            <mat-form-field appearance="outline" class="w-100">
                                                <mat-label>Teléfono</mat-label>
                                                <input matInput formControlName="phoneNumber" tabindex="6"
                                                    placeholder="sin 15 - ej: 3456888" />
                                            </mat-form-field>

                                            <mat-form-field appearance="outline" class="w-100">
                                                <mat-label>Profesión</mat-label>
                                                <input matInput formControlName="occupation" tabindex="8" />
                                            </mat-form-field>

                                            <mat-form-field appearance="outline" class="w-100">
                                                <mat-label>País de destino</mat-label>
                                                <mat-select formControlName="destinationCountry" tabindex="10">
                                                    <mat-option>
                                                        <ngx-mat-select-search [formControl]="countryFilterCtrl"
                                                            placeholderLabel="Buscar país..."></ngx-mat-select-search>
                                                    </mat-option>
                                                    <mat-option>Seleccione...</mat-option>
                                                    <mat-option *ngFor="let country of filteredCountries"
                                                        [value]="country.name">
                                                        {{ country.name }}
                                                    </mat-option>
                                                </mat-select>
                                            </mat-form-field>

                                            <mat-form-field appearance="outline" class="w-100">
                                                <mat-label>Dirección de origen</mat-label>
                                                <input matInput formControlName="originAddress" tabindex="12" />
                                            </mat-form-field>

                                            <mat-form-field appearance="outline" class="w-100">
                                                <mat-label>Patente</mat-label>
                                                <input matInput formControlName="licensePlate" tabindex="14" />
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <mat-form-field appearance="outline" class="w-100 mt-2 guest-observation">
                                            <mat-label>Observaciones</mat-label>
                                            <textarea matInput formControlName="observations" tabindex="15"></textarea>
                                        </mat-form-field>
                                    </div>
                                    <div class="row w-100 d-block" *ngIf="!guest.get('isBookingPerson')?.value">
                                        <button type="button" mat-mini-fab class="float-right custom-fab-red-circle"
                                            aria-label="Quitar huésped" title="Quitar huésped"
                                            (click)="removeGuest(guest)">
                                            <mat-icon>person_remove</mat-icon>
                                        </button>
                                    </div>
                                </mat-expansion-panel>
                            </div>
                        </div>
                    </ng-container>

                    <ng-template #emptyPlaceholder>
                        <div class="empty-dropzone-placeholder">
                            Arrastrá un huésped aquí
                        </div>
                    </ng-template>
                </div>
                <mat-divider class="my-3"></mat-divider>
            </div>
        </mat-accordion>
        <div class="row justify-content-end">
            <button type="button" (click)="submit(false)">
                Guardar
            </button>
            <button *ngIf="showSaveBtn()" type="button" class="ml-1" (click)="submit(true)" [disabled]="desableSaveBtn()">
                Guardar y confirmar
            </button>
        </div>
    </form>
</div>